import { defineStore } from 'pinia'

export const useThemeStore = defineStore('theme', {
  state: () => ({
    isSunnyMode: true // Default to Sunny mode
  }),
  
  actions: {
    toggleTheme() {
      this.isSunnyMode = !this.isSunnyMode
      this.saveThemePreference()
    },
    
    setSunnyMode() {
      this.isSunnyMode = true
      this.saveThemePreference()
    },
    
    setRainyMode() {
      this.isSunnyMode = false
      this.saveThemePreference()
    },
    
    initTheme() {
      // Check if user has a saved preference
      const savedTheme = localStorage.getItem('theme-preference')
      if (savedTheme) {
        this.isSunnyMode = savedTheme === 'sunny'
      } else {
        // If no preference, check system preference
        const prefersDarkMode = window.matchMedia('(prefers-color-scheme: dark)').matches
        this.isSunnyMode = !prefersDarkMode
      }
    },
    
    saveThemePreference() {
      localStorage.setItem('theme-preference', this.isSunnyMode ? 'sunny' : 'rainy')
    }
  }
}) 